/* @flow */
import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import TextField from 'material-ui/TextField';
import Badge from 'material-ui/Badge';
import { Tab, Tabs } from 'material-ui/Tabs';
import EmailIcon from 'material-ui/svg-icons/communication/email';
import PhoneIcon from 'material-ui/svg-icons/communication/phone';
import IconButton from 'material-ui/IconButton';

import StudentBooked from './components/StudentBooked';
import StudentHistory from './components/StudentHistory';
import StudentPending from './components/StudentPending';

import type { Student_student } from './__generated__/Student_student.graphql';

import enhancer from '../../enhancer';

const styles = {
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
};

type Props = {
  student: Student_student,
  variables: {
    nodeId: string,
  },
};

type State = {
  tab: string,
};

class Student extends Component<Props, State> {
  state = {
    tab: 'booked',
  };

  handleChange = tab => {
    this.setState({ tab });
  };

  renderTabs() {
    const { student, variables: { nodeId } } = this.props;
    const { tab } = this.state;

    return (
      <Tabs value={tab} onChange={this.handleChange}>
        <Tab
          label={
            <Badge
              badgeContent={student.startedJobSessionCount}
              secondary
              badgeStyle={{ top: 12, right: -10 }}
            >
              Booked
            </Badge>
          }
          value="booked"
        >
          {tab === 'booked' && (
            <StudentBooked nodeId={nodeId} student={student} />
          )}
        </Tab>
        <Tab
          label={
            <Badge
              badgeContent={student.pendingJobRequestsCount}
              secondary
              badgeStyle={{ top: 12, right: -10 }}
            >
              Pending
            </Badge>
          }
          value="pending"
        >
          {tab === 'pending' && <StudentPending student={student} />}
        </Tab>
        <Tab label="History" value="history">
          {tab === 'history' && (
            <StudentHistory nodeId={nodeId} student={student} />
          )}
        </Tab>
      </Tabs>
    );
  }

  render() {
    const { student } = this.props;

    return (
      <div>
        <div style={styles.header}>
          <form>
            <TextField
              floatingLabelText="Firstname"
              value={student.firstname}
              floatingLabelFixed
            />
            <br />
            <TextField
              floatingLabelText="Lastname"
              value={student.lastname}
              floatingLabelFixed
            />
            <br />
            <TextField
              floatingLabelText="Cell"
              value={student.cellphoneNumber}
              floatingLabelFixed
            />
            {student.cellphoneNumber ? (
              <IconButton
                tooltip="Cell"
                href={`tel:${student.cellphoneNumber}`}
              >
                <PhoneIcon />
              </IconButton>
            ) : null}
            <br />
            {student.user && (
              <div>
                <TextField
                  floatingLabelText="Email"
                  value={student.user.email}
                  floatingLabelFixed
                />
                <IconButton
                  tooltip="Email"
                  href={`mailto:${student.user.email}`}
                >
                  <EmailIcon />
                </IconButton>
                <br />

                <TextField
                  floatingLabelText="Status"
                  value={student.user.status}
                  floatingLabelFixed
                />
              </div>
            )}
            <br />
            <br />
          </form>
          <div style={{ padding: 20 }}>
            <img
              alt="Student"
              width={300}
              src={student.profilePictureThumbnailUri}
            />
          </div>
        </div>

        <div>{this.renderTabs()}</div>
      </div>
    );
  }
}

const query = graphql`
  query StudentAdminQuery(
    $nodeId: ID!
    $historyCursor: String
    $historyCount: Int
    $bookedCursor: String
    $bookedCount: Int
  ) {
    student: node(id: $nodeId) {
      ...Student_student
    }
  }
`;

export default enhancer(Student, {
  relay: {
    variables: {
      historyCount: 10,
      bookedCount: 10,
    },
    query,
    create: () =>
      createFragmentContainer(Student, {
        student: graphql`
          fragment Student_student on Student {
            ...StudentBooked_student
            ...StudentPending_student
            ...StudentHistory_student
            id
            firstname
            lastname
            profilePictureThumbnailUri
            startedJobSessionCount
            pendingJobRequestsCount
            cellphoneNumber
            user {
              email
              status
              active
            }
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/modules/admin/student/Student.js